export default __webpack_public_path__ + "static/Sally_Mower-0bd44a8e8bbb4ee2f5334c8227213ab8.jpg";